import { editTaskConstant } from 'src/redux/actions/constant';

const {
  EDIT_TASK_THERAPIST_SCHEDULING_REQUEST,
  EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS,
  EDIT_TASK_THERAPIST_SCHEDULING_FAILURE,
  EDIT_TASK_THERAPIST_SCHEDULING_RESET,
  EDIT_TASK_THERAPIST_SCHEDULING_LOADING,
} = editTaskConstant;

const intialState: object = {
  response: null,
  isEditedTask: false,
  loading: false,
};

export const therapistSchedulingTaskEditReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS:
      return {
        ...state,
        response: action.payload,
        isEditedTask: true,
        loading: false,
      };

    case EDIT_TASK_THERAPIST_SCHEDULING_FAILURE:
      return {
        ...state,
        response: action.payload,
        isEditedTask: false,
        loading: false,
      };

    case EDIT_TASK_THERAPIST_SCHEDULING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case EDIT_TASK_THERAPIST_SCHEDULING_RESET:
      return {
        ...state,
        response: null,
        isEditedTask: false,
        loading: false,
      };

    default:
      return state;
  }
};
